import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CalendarModule } from "primeng/calendar";
import { ButtonModule } from "primeng/button";
import { OverlayPanel, OverlayPanelModule } from "primeng/overlaypanel";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { DropdownModule } from "primeng/dropdown";
import moment from "moment";

@Component({
    selector: "app-home-date-filter",
    templateUrl: "./home-date-filter.component.html",
    standalone: true,
    imports: [
        CalendarModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        OverlayPanelModule,
        SharedComponentsModule,
        DropdownModule,
    ],
    styleUrl: "./home-date-filter.component.scss",
})
export class HomeDateFilterComponent implements OnInit {
    @Input() filterForm!: FormGroup;
    @Output() filterApplied = new EventEmitter<string>();

    selectedFilter: string = "next7Days";
    appliedFilter: string = "next7Days";
    showHeader: boolean = true;
    @ViewChild("op") overlayPanel: OverlayPanel;

    pendingStartDate: Date | null = null;
    pendingEndDate: Date | null = null;

    ngOnInit() {
        // Initialize with "next 7 days" filter
        this.selectFilter("next7Days");
        this.applyFilter();
    }

    selectFilter(filter: string) {
        this.selectedFilter = filter;
        const today = new Date();
        let startDate: Date | null = null;
        let endDate: Date | null = null;

        switch (filter) {
            case "pastDue":
                const lastYear = new Date();
                lastYear.setDate(lastYear.getDate() - 1);
                lastYear.setFullYear(lastYear.getFullYear() - 1);
                startDate = lastYear;
                endDate = new Date(today);
                endDate.setDate(today.getDate() - 1);
                break;
            case "today":
                startDate = today;
                endDate = today;
                break;
            case "next7Days":
                startDate = new Date(today);
                endDate = new Date(today);
                endDate.setDate(endDate.getDate() + 6);
                break;
        }

        this.pendingStartDate = startDate;
        this.pendingEndDate = endDate;

        this.applyFilter();
        this.overlayPanel?.hide();
    }

    getDisplayLabel(): string {
        switch (this.appliedFilter) {
            case "pastDue":
                return "Past Due";
            case "today":
                return "Today";
            case "next7Days":
                return "Next 7 Days";
            default:
                const start = this.filterForm.get("startDate")?.value;
                const end = this.filterForm.get("endDate")?.value;
                if (start || end) {
                    const formattedStart = start
                        ? moment(start).format("MM/DD")
                        : "...";
                    const formattedEnd = end
                        ? moment(end).format("MM/DD")
                        : "...";
                    return `${formattedStart} - ${formattedEnd}`;
                }
                return "Select Date";
        }
    }

    applyFilter() {
        this.appliedFilter = this.selectedFilter;
        this.filterApplied.emit(this.appliedFilter);

        this.filterForm.patchValue({
            startDate: this.pendingStartDate,
            endDate: this.pendingEndDate,
        });

        const parentForm = this.filterForm.parent;
        if (parentForm && parentForm instanceof FormGroup) {
            if (this.selectedFilter === "pastDue") {
                parentForm.patchValue({ pastDue: true });
            } else {
                parentForm.patchValue({ pastDue: false });
            }
        }
    }

    toggleHeader() {
        this.showHeader = !this.showHeader;
    }

    onDatePicked(): void {
        this.selectedFilter = "";
        const parentForm = this.filterForm.parent;
        if (parentForm && parentForm instanceof FormGroup) {
            parentForm.patchValue({ pastDue: false });
        }
    }

    resetToDefault(): void {
        this.selectFilter("next7Days");
        const parentForm = this.filterForm.parent;
        if (parentForm && parentForm instanceof FormGroup) {
            parentForm.patchValue({ pastDue: false });
        }
    }

    setFilterType(filter: string): void {
        this.selectFilter(filter);
    }
}
